let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g5HnJ")).then(() => parcelRequire('esyh1'));